import React from 'react';
import AdminNavbar from './AdminNavbar';

const AdminNavbarWrapper = ({
  showNavbar,
  // theme,
  baseUrl = null,
  baseFceUrl = null,
  baseApiUrl = null,
  baseAdminUrl = null,
  mode,
  setHeaderHeight,
}) => (
  // <ThemeProvider theme={theme}>
  <AdminNavbar
    showNavbar={showNavbar}
    baseUrl={baseUrl}
    baseFceUrl={baseFceUrl}
    baseApiUrl={baseApiUrl}
    baseAdminUrl={baseAdminUrl}
    mode={mode}
    setHeaderHeight={setHeaderHeight}
  />
  // </ThemeProvider>
);

export default AdminNavbarWrapper;
